module.exports = __webpack_public_path__ + "img/checkedAi.f912c49b.png";